import { dataTrendMonitorSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrendMonitorSolid = /*#__PURE__*/createIcon(dataTrendMonitorSolid)
export default IconTrendMonitorSolid
